<template>
    <li class="has-sub" @click="hideSidebar">
        <router-link :to="`/channel/${course.id}`" :title="course.name">
            <img class="aside-menu__icon" :src="course.icon | imgSrc" alt="" width="22px">
            <span class="title">{{ course.name }}</span>
            <div class="sub__notification sub__notification--courses" v-if="notifications">{{ notifications }}</div>
        </router-link>
    </li>
</template>

<script>
    import {mapActions} from 'vuex';

    export default {
        props: ['course'],
        components: {
            //
        },
        computed: {
            notifications() {
                return this.course.unread_messages_count <= 0 ? false : this.course.unread_messages_count
            }
        },
        methods: {
            ...mapActions(['toggleSidebarLeft']),
            hideSidebar() {
                const ww = window.innerWidth;

                if (ww < 768) this.toggleSidebarLeft(false);
            }
        }
    }
</script>
